import React from 'react';
const body = ['Every wedding runs late. And when it does, the first thing that gets cut is your portrait time.', 'Which means the photographers with the best galleries aren’t the most talented — they’re the ones who control the clock. And you can’t control the clock while you’re improvising what to say next.', 'So confidence isn’t a personality trait. It isn’t “experience” either — experience is just the slowest, most expensive way to build a system, paid for in soft galleries and lukewarm reviews.', 'The wedding day already has a script: what to say, where to stand, how many minutes each part takes, and what breaks when it runs late.'];
export function BigIdea() {
  return <section className="w-full bg-ink py-20 sm:py-28" data-id="element-24" data-mp="2g9s1wb9fh0ga">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-25" data-mp="2gbcwg0vqsje5">
        <h2 className="font-serif text-3xl leading-snug sm:text-[2.9rem] sm:leading-[1.18] text-ivory" data-id="element-26" data-mp="1isupiwbtv4yv">
          The difference between the photographer who freezes at golden hour and the one
          who&rsquo;s the calmest person in the room isn&rsquo;t talent. And it
          isn&rsquo;t experience.
        </h2>
        <p className="mt-8 font-serif text-4xl italic sm:text-6xl text-gold" data-id="element-27" data-mp="2p37qi82zvg5q">
          It&rsquo;s the script.
        </p>
        <div className="rule-gold mx-auto mt-10 w-40" aria-hidden="true" data-id="element-28" data-mp="2k9lbwad9t27a" />

        <div className="mx-auto mt-10 max-w-2xl space-y-6 text-left" data-id="element-29" data-mp="2g9uo8fj1j26z">
          {body.map(paragraph => <p key={paragraph} className="text-base sm:text-lg leading-relaxed text-ivory/70" data-id="element-30" data-mp="2bckp285unc5y">
              {paragraph}
            </p>)}
          <p className="font-serif text-2xl italic leading-snug text-ivory" data-id="element-31" data-mp="21ck82svgd84x">
            You were just never handed a copy.
          </p>
        </div>
      </div>
    </section>;
}